import { createContext, useContext, useEffect } from 'react'

/**
 * Có giá trị khi panel chi tiết đang nằm trong `KiotListExpandDetailModal`:
 * `footerHost` = vùng footer BaseModal để portal nút hành động.
 */
export type KiotListExpandModalContextValue = {
  footerHost: HTMLElement | null
  setEditLocked: (locked: boolean) => void
}

export const KiotListExpandModalContext = createContext<KiotListExpandModalContextValue | null>(null)

export const useKiotListExpandModal = () => useContext(KiotListExpandModalContext)

/** Panel chi tiết đang hiển thị trong modal (không phải dòng mở rộng) — ẩn sửa inline, nút sửa riêng. */
export const useKiotListExpandInModal = () => useContext(KiotListExpandModalContext) != null

/** Panel báo bản ghi đã khóa (hoàn thành / hủy…) → modal ẩn nút «Chỉnh sửa» ở footer. */
export const useKiotListExpandModalEditLock = (locked: boolean) => {
  const setEditLocked = useContext(KiotListExpandModalContext)?.setEditLocked
  useEffect(() => {
    if (!setEditLocked) return
    setEditLocked(locked)
    return () => setEditLocked(false)
  }, [locked, setEditLocked])
}
